import { IZeosApiResponse } from "../contracts/ZeosApi";
import { IUtilityIntelligenceProfile } from "../contracts/UtilityIntelligence";
import { getDataAsync, postDataReturnAsync } from "../ZeosApiExecutor";
import { ITerritory } from "./interfaces/ITerritory";

// TerritoryController is v2. Xhr builds `${apiUrl}/v1.0${path}`, so the path must start with "/":
// "/../v2/territory/" gives ".../v1.0/../v2/territory/", which the browser resolves to ".../v2/territory/"
// (keeping any path base such as /zeos-api). Without the leading slash it was ".../v1.0../v2/..." -> 404.
const prefix = "/../v2/territory/";

export const Territory: ITerritory = {
  getProfileAsync: async (propertyId: number): Promise<IZeosApiResponse<IUtilityIntelligenceProfile>> => {
    return await getDataAsync<IUtilityIntelligenceProfile>(`${prefix}${propertyId}`, "data");
  },
  // POST since task-4052: resolving writes assignments, so it is no longer a GET.
  resolveProfileAsync: async (propertyId: number): Promise<IZeosApiResponse<IUtilityIntelligenceProfile>> => {
    return await postDataReturnAsync<IUtilityIntelligenceProfile>(`${prefix}resolve/${propertyId}`, {}, "data");
  },
  proposeProfileAsync: async (
    address?: string,
    city?: string,
    state?: string,
    zip?: string
  ): Promise<IZeosApiResponse<IUtilityIntelligenceProfile>> => {
    const params = new URLSearchParams();
    if (address) params.set("address", address);
    if (city) params.set("city", city);
    if (state) params.set("state", state);
    if (zip) params.set("zip", zip);
    const query = params.toString() ? `?${params.toString()}` : "";
    return await getDataAsync<IUtilityIntelligenceProfile>(`${prefix}propose${query}`, "data");
  },
};
